import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import _map from 'lodash/map';
import classNames from 'classnames/bind';
import * as styles from './LinkFarm.css';

const cx = classNames.bind(styles);

class LinkFarm extends PureComponent {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(category, e) {
        e.preventDefault();

        /* istanbul ignore next */
        const {
            target: { href = '', innerText },
        } = e;
        const softRouteURL = href;

        if (softRouteURL) {
            const { triggerNavigationClick } = this.props;
            const eventConent = `left:${category}:${innerText}`;

            triggerNavigationClick({
                isReload: false,
                linkName: eventConent,
            });

            window.location.href = softRouteURL;
        }
    }

    renderDepartmentHeader = (category, subItems) => {
        const { automationId, categoryLink } = this.props;

        return (
            <div className={cx('navSubHeaderBlock', 'linkFarmContainer')}>
                {categoryLink ? (
                    <a className={cx('navSubHeader')} href={categoryLink}>
                        {category}
                    </a>
                ) : (
                    <div className={cx('navSubHeader')}>{category}</div>
                )}
                <ul className={cx('navSubHeaderItem')} data-automation-id={automationId}>
                    {this.renderSubHeaderItems(subItems, category)}
                </ul>
            </div>
        );
    };

    renderSubHeaderItems = (items, category) =>
        _map(items, (item) => {
            const { imageUrl, name, targetUrl, targetWindow } = item;

            return (
                <li className={cx('navSubHeaderListItem')} key={name}>
                    {imageUrl && <img src={imageUrl} className={cx('imageIcons')} alt="" />}
                    <a
                        className={cx('navSubHeaderItemLink')}
                        data-automation-id="department-navigation-link"
                        data-type={targetWindow}
                        href={targetUrl}
                        onClick={(event) => {
                            this.handleClick(category, event);
                        }}
                    >
                        {name}
                    </a>
                </li>
            );
        });

    render() {
        const { category, items } = this.props;
        return this.renderDepartmentHeader(category, items);
    }
}

/* istanbul ignore next */
LinkFarm.defaultProps = {
    automationId: 'link-farm',
    category: '',
    categoryLink: '',
    triggerNavigationClick: () => {},
};

LinkFarm.propTypes = {
    automationId: PropTypes.string,
    category: PropTypes.string,
    categoryLink: PropTypes.string,
    items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    triggerNavigationClick: PropTypes.func,
};

export default LinkFarm;
